module.exports = __webpack_public_path__ + "officialStatic/img/product-zzxy.bbcdff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-zzxy.png
// module id = fY34
// module chunks = 0